/* necta.one Icon-Satz — kuratierte Tabler-Icons (Soll: claude.ai/design-Projekt
   „necta.one Design System – latest", assets/icons/icons.js — Tabler v3, Stroke 2).
   Neue Icons werden zuerst im Design-Projekt ergänzt, dann hier registriert.
   Registrierung global in app.config.ts (provideTablerIcons), weil app-tabs /
   app-section-header Icon-Namen dynamisch per Input erhalten. */
import {
  IconBell,
  IconBolt,
  IconBox,
  IconBuilding,
  IconBuildingStore,
  IconCalendar,
  IconChartBar,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircleCheck,
  IconClock,
  IconCpu,
  IconDeviceFloppy,
  IconFileSpreadsheet,
  IconFileText,
  IconFilter,
  IconFilterOff,
  IconFolder,
  IconHelp,
  IconHome,
  IconInbox,
  IconList,
  IconLogout,
  IconMenu2,
  IconMinus,
  IconPalette,
  IconPencil,
  IconPlus,
  IconSearch,
  IconSend,
  IconSettings,
  IconShoppingCart,
  IconShoppingCartPlus,
  IconTable,
  IconTerminal2,
  IconTool,
  IconTrash,
  IconTruck,
  IconUser,
  IconUsers,
  IconWallet,
  IconX,
} from 'angular-tabler-icons/icons';

/** Qassandra-Biene (Marken-Icon, Füll-Pfad statt Tabler-Stroke).
    Pfad-Quelle: src/assets/img/qassandra.svg — bei Logo-Updates beide Stellen pflegen. */
const IconQassandra = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600" fill="currentColor" stroke="none"><path d="M389.46,414.72c1.32-1.45,2.61-2.95,3.89-4.46,22.48-3.31,47.24-10.43,63.96-22.23,83.42-58.15,6.65-224.28-56.62-279.56,10.05-17.24,26.29-36.76,52.27-44.75,3.34,8.24,11.42,14.06,20.86,14.06,29.85-1.19,29.84-43.82,0-45-11.9,0-21.64,9.24-22.44,20.94-28.8,8.22-47.25,29.51-58.31,48.01-58.67-50.31-126.7-51.24-186.5.01-11.06-18.51-29.51-39.8-58.31-48.02-.8-11.7-10.54-20.94-22.44-20.94-29.85,1.19-29.84,43.82,0,45,9.44,0,17.52-5.82,20.86-14.06,25.99,8,42.22,27.52,52.28,44.77-66.03,58.82-139.33,222.83-55.89,280.06,16.64,11.48,41.06,18.45,63.24,21.72,1.04,1.24,2.1,2.46,3.18,3.66,3.74,10.87,11.4,34.09,14.51,52.07,1.03,5.9-2.61,11.66-8.37,13.21,0,0-26.97,7.34-26.97,7.34h0s-64.56,17.58-64.56,17.58c-10.78,2.86-11.23,18.13-.72,21.76,118.25,41.18,236.31,42.23,353.41.07h0c10.44-3.68,9.86-18.9-.86-21.74,0,0-53.31-14.52-53.31-14.52h0c-2.5-.68-9.23-2.51-11.64-3.17h0s-26.97-7.34-26.97-7.34c-5.68-1.54-9.3-7.15-8.39-12.99,2.74-9.79,4.98-17.8,6.82-24.37-4.21,3.38-8.55,6.49-12.99,9.32-1.38,4.94-2.63,9.39-3.54,12.65l-.19,1.03c-1.59,10.82,5.15,21.14,15.67,24l17.62,4.8c-45.34,16.86-152.92,16.89-198.38,0l17.6-4.79c10.7-2.89,17.47-13.54,15.61-24.53-1.9-11.11-5.6-24.48-9.03-35.6,50.12,42.63,120.48,35.84,164.64-14.01ZM382.06,407.99c-45.69,51.7-118.81,51.71-164.5,0-49.78-52.62-58.5-152.6-22.02-217.02,46.95,34.36,116.04,22.69,149.03-25.24,16.12,22.89,40.43,38.46,68.01,43.44,26.46,63.03,14.69,150.88-30.53,198.83Z"/></svg>`;

export const NECTA_TABLER_ICONS = {
  IconBell,
  IconBolt,
  IconBox,
  IconBuilding,
  IconBuildingStore,
  IconCalendar,
  IconChartBar,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircleCheck,
  IconClock,
  IconCpu,
  IconDeviceFloppy,
  IconFileSpreadsheet,
  IconFileText,
  IconFilter,
  IconFilterOff,
  IconFolder,
  IconHelp,
  IconHome,
  IconInbox,
  IconList,
  IconLogout,
  IconMenu2,
  IconMinus,
  IconPalette,
  IconPencil,
  IconPlus,
  IconQassandra,
  IconSearch,
  IconSend,
  IconSettings,
  IconShoppingCart,
  IconShoppingCartPlus,
  IconTable,
  IconTerminal2,
  IconTool,
  IconTrash,
  IconTruck,
  IconUser,
  IconUsers,
  IconWallet,
  IconX,
};

/** kebab-case-Namen für <i-tabler name="…"> — Referenzliste der Icons-Showcase-Seite. */
export const NECTA_ICON_NAMES: string[] = Object.keys(NECTA_TABLER_ICONS).map((k) =>
  k
    .replace(/^Icon/, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-z])(\d)/g, '$1-$2') // IconMenu2 → menu-2
    .toLowerCase(),
);
